import { useState } from 'react';

import { toast_error } from '@/libs/toast-wrappers';
import { getNpiProviders, GetNpiProvidersParams, NpiProvider } from '@/api/npi-preferred';

export const useGetNpiProvidersByFilter = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<NpiProvider[]>([]);

  const request = async (filters: GetNpiProvidersParams) => {
    setLoading(true);

    try {
      const response = await getNpiProviders(filters);
      setData(response);
    } catch {
      toast_error('Error fetching NPI providers');
    }

    setLoading(false);
  };

  return { data, loading, request };
};
